<template>
  <div class="top">
    <div class="content">
      <img
        src="../../assets/head_logo.png"
        alt=""
        class="logo"
        @click="navToHome"
      />
      <div class="nav_area">
        <div class="right" :class="{ open: menuOpen }">
          <ul class="navs">
            <li
              :class="{ nav: true, active: $route.path == '/home' }"
              @click="navTo('/home')"
            >
              {{ $t("message.top.nav1") }}
            </li>
            <li
              :class="{ nav: true, active: $route.path == '/intro' }"
              @click="navTo('/intro')"
            >
              {{ $t("message.top.nav2") }}
            </li>
            <li
              :class="{ nav: true, active: $route.path == '/manager' }"
              @click="navTo('/manager')"
            >
              {{ $t("message.top.nav3") }}
            </li>
            <li
              :class="{ nav: true, active: $route.path == '/contact' }"
              @click="navTo('/contact')"
            >
              {{ $t("message.top.nav6") }}
            </li>
          </ul>
        </div>
        <div class="lang_wrap">
          <el-dropdown
            trigger="click"
            placement="bottom"
            @command="langChange"
            size="small"
          >
            <span class="link">
              <img
                class="lang_icon"
                v-if="defaultLang == 'jp'"
                src="@/assets/japanese.png"
                alt=""
              />
              <img class="lang_icon" v-else src="@/assets/china.png" alt="" />
              {{ handleLang }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="ch" class="item">
                <img class="lang_icon" src="@/assets/china.png" alt="" />
                <div class="lang">{{ $t("message.bottom.lang1") }}</div>
              </el-dropdown-item>
              <el-dropdown-item command="jp" class="item">
                <img class="lang_icon" src="@/assets/japanese.png" alt="" />
                <div class="lang">{{ $t("message.bottom.lang2") }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <button
          class="menu_toggle"
          type="button"
          aria-label="menu"
          @click="menuOpen = !menuOpen"
        >
          <i :class="menuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
        </button>
      </div>
    </div>
    <div class="menu_mask" v-show="menuOpen" @click="menuOpen = false"></div>
  </div>
</template>
<script>
import router from "../../router/menuRoutes";
import { setManualLang } from "@/util/lang";
export default {
  data() {
    return {
      routes: [],
      defaultLang: "jp",
      menuOpen: false,
    };
  },
  computed: {
    handleLang() {
      return this.defaultLang === "jp"
        ? this.$t("message.bottom.lang2")
        : this.$t("message.bottom.lang1");
    },
  },
  watch: {
    $route() {
      this.menuOpen = false;
    },
  },
  mounted() {
    this.routes = router.children;
    this.defaultLang = this.$i18n.locale || "jp";
  },
  methods: {
    langChange(command) {
      setManualLang(command);
      setTimeout(() => {
        this.$i18n.locale = command;
        this.defaultLang = command;
        this.$forceUpdate();
      }, 100);
    },
    navTo(path) {
      this.menuOpen = false;
      if (this.$route.path != path) {
        this.$router.push(path);
      }
    },
    navToHome() {
      this.menuOpen = false;
      if (this.$route.path != "/home") {
        this.$router.push("/home");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  height: 80px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: $page-bg;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.menu_toggle {
  display: none;
  border: none;
  background: transparent;
  font-size: 24px;
  color: $text-dark;
  cursor: pointer;
  padding: 4px;
}

.menu_mask {
  display: none;
}

::v-deep .item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: youyuan;
}

.content {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo {
    width: 200px;
    max-width: 180px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .nav_area {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .navs {
    display: flex;
    align-items: center;
    gap: 8px;

    .nav {
      padding: 8px 16px;
      color: $text-dark;
      font-weight: 500;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      position: relative;
      background: transparent;

      &::after {
        content: "";
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 0;
        height: 2px;
        background-color: $theme;
        opacity: 0;
        transition: opacity 0.2s;
      }

      &:hover {
        color: $theme;
      }
    }

    .active {
      color: $text-dark;
      font-weight: 600;

      &::after {
        opacity: 1;
      }
    }
  }

  .lang_wrap {
    .link {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      user-select: none;
      color: $text-dark;
      white-space: nowrap;
      padding: 6px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background: #fff;
      font-size: 13px;
    }
  }
}

.lang_icon {
  width: 18px;
  vertical-align: middle;
}

@include respond-md {
  .top {
    height: 64px;
  }

  .menu_toggle {
    display: block;
  }

  .menu_mask {
    display: block;
    position: fixed;
    inset: 64px 0 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 98;
  }

  .content {
    padding: 0 16px;

    .logo {
      max-width: 130px;
    }

    .nav_area {
      gap: 8px;
    }

    .lang_wrap {
      order: 1;
      flex-shrink: 0;
    }

    .menu_toggle {
      order: 2;
    }

    .right {
      position: fixed;
      top: 64px;
      right: 0;
      width: 260px;
      max-width: 82vw;
      height: calc(100vh - 64px);
      background: #fff;
      box-shadow: -2px 0 12px rgba(0, 0, 0, 0.12);
      transform: translateX(100%);
      transition: transform 0.3s ease;
      z-index: 99;
      overflow-y: auto;

      &.open {
        transform: translateX(0);
      }
    }

    .navs {
      flex-direction: column;
      align-items: stretch;
      padding: 12px 0;
      gap: 0;

      .nav {
        width: 100%;
        text-align: left;
        padding: 0 20px;
        line-height: 48px;
        border-bottom: 1px solid #f0f0f0;

        &::after {
          left: 20px;
          right: auto;
          width: 40px;
        }
      }
    }
  }
}
</style>
